module.exports = __webpack_public_path__ + "static/media/bg-4.ab01d8c2.png";